var React = require('react');

function IconHtml (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0L2.33705 26.5045L12.8237 30L23.3772 26.5045L25.7143 0H0ZM20.6384 8.56473H8.33036L8.60491 11.8728H20.3638L19.4531 21.8103L12.8973 23.6183V23.6384H12.8237L6.21429 21.8103L5.8125 16.7344H9.0067L9.24107 19.2857L12.8237 20.2567L16.4196 19.2857L16.8214 15.1205H5.64509L4.78795 5.37054H20.933L20.6384 8.56473Z","fill":"#fff"}));
}

IconHtml.defaultProps = {"width":"26","height":"30","viewBox":"0 0 26 30","fill":"none"};

module.exports = IconHtml;

IconHtml.default = IconHtml;
